import axios from 'axios';

export async function init({ commit, dispatch }) {
	await dispatch('get');
	commit('INIT');
}

export async function get({ commit }) {
	const { data } = await axios.get('/chatbot');
	commit('SET_ENABLED', data.enabled);
	commit('SET_AUTOREPLY', data.autoreply);
	commit('SET_NAME', data.name);
	commit('SET_OPEN_HOURS', data.openHours);
	commit('UPDATE_QUESTIONS', data.questions);
}

export async function saveEnabled({ commit, state }, enabled) {
	if (enabled != null) commit('SET_ENABLED', enabled);
	await axios.post('/chatbot', { enabled: state.enabled });
}

export async function saveAutoreply({ commit, state }, autoreply) {
	commit('SET_AUTOREPLY', autoreply || null);
	await axios.post('/chatbot', { autoreply: state.autoreply });
}

export async function saveName({ commit, state }, name) {
	if (name) commit('SET_NAME', name);
	await axios.post('/chatbot', { name: state.name });
}

export async function saveOpenHours({ commit, state }, openHours) {
	if (openHours) commit('SET_OPEN_HOURS', openHours);
	await axios.post('/chatbot', { openHours: state.openHours });
}

export async function saveQuestions({ commit, state }, questions) {
	if (questions) commit('UPDATE_QUESTIONS', questions);
	await axios.post('/chatbot', { questions: state.questions });
}
